import { T } from 'consts/translationKeys'
import { translate } from 'utils/translations'
import { useAvatarUpload } from '../../../../hooks/useAvatarUpload'
import AvatarActionButton from '../action-btn/AvatarActionButton'
import * as Styled from './styled'

const DeleteAvatarButton = () => {
  const { handleRemoveAvatar } = useAvatarUpload()

  return (
    <AvatarActionButton
      icon={<Styled.DeleteIcon />}
      tooltipText={translate(T.DELETE_LABEL)}
      onClick={handleRemoveAvatar}
      testId="avatar-preview-delete"
    />
  )
}

export default DeleteAvatarButton
